import React from 'react';
import { ChatBubble, CheckCircle, PeopleAlt } from '@material-ui/icons';
import { AccessTimeFilled, Phone, PhoneForwarded } from '@mui/icons-material';
import { ACTIVE_CHATS_TITLE, DEALS_CLOSED_TITLE, STARTED_MESSAGES_TITLE, UNREAD_MESSAGES_TITLE, CALLS_MADE_TITLE, CALLS_WITH_ANSWER_TITLE } from './hooks/utils';

export const Card = ( { item, value } ) => {
	const iconLiteral = {
		totalActiveChatsJarvis          			: <PeopleAlt style={{ color: '#008069' }} />,
		totalActiveChatsNegotiators     			: <PeopleAlt style={{ color: '#008069' }} />,
		totalDealClosedByNegotiators    			: <CheckCircle style={{ color: '#008069' }} />,
		totalDealsClosedByIA            			: <CheckCircle style={{ color: '#008069' }} />,
		totalStartedMessagesJarvis      			: <ChatBubble style={{ color: '#008069' }} />,
		totalStartedMessagesNegotiators 			: <ChatBubble style={{ color: '#008069' }} />,
		totalUnreadCountJarvis          			: <AccessTimeFilled style={{ color: '#008069' }} />,
		totalUnreadCountNegotiators     			: <AccessTimeFilled style={{ color: '#008069' }} />,
		totalCallsMadeByIA          				: <Phone style={{ color: '#008069' }} />,
		totalCallsMadeByNegotiators     			: <Phone style={{ color: '#008069' }} />,
		totalCallsMadeByIAWithAnswer          		: <PhoneForwarded style={{ color: '#008069' }} />,
		totalCallsMadeByNegotiatorsWithAnswer     	: <PhoneForwarded style={{ color: '#008069' }} />,
	};
	const titleLiteral = {
		totalActiveChatsJarvis          		: ACTIVE_CHATS_TITLE,
		totalActiveChatsNegotiators     		: ACTIVE_CHATS_TITLE,
		totalDealClosedByNegotiators    		: DEALS_CLOSED_TITLE,
		totalDealsClosedByIA            		: DEALS_CLOSED_TITLE,
		totalStartedMessagesJarvis      		: STARTED_MESSAGES_TITLE,
		totalStartedMessagesNegotiators 		: STARTED_MESSAGES_TITLE,
		totalUnreadCountJarvis          		: UNREAD_MESSAGES_TITLE,
		totalUnreadCountNegotiators           	: UNREAD_MESSAGES_TITLE,
		totalCallsMadeByIA            		  	: CALLS_MADE_TITLE,
		totalCallsMadeByNegotiators 			: CALLS_MADE_TITLE,
		totalCallsMadeByIAWithAnswer      	  	: CALLS_WITH_ANSWER_TITLE,
		totalCallsMadeByNegotiatorsWithAnswer 	: CALLS_WITH_ANSWER_TITLE,
	};

	if ( !titleLiteral[item] ) {
		return null;
	}

	return (
		<div className='Card'>
			<div style={{ padding: '12px 0px' }}>
				<div style={{ backgroundColor: '#EAEFE9', padding: '12px', borderRadius: '50%' }}>
        	{iconLiteral[item]}
				</div>
			</div>
			<div style={{ display: 'flex', flexDirection: 'column', gap: '8px', justifyContent: 'center' }}>
				<span className='CardTitle'>{titleLiteral[item]}</span>
				<span className='CardValue'>{value}</span>
			</div>
		</div>
	);
};